import React, { useState } from "react";
import styled, { css } from "styled-components";
import { Alert, Col, Modal } from "components/bootstrap";
import { Select, Spinner } from "components/common";
import FileSystemRepositoryModalForm from "./FileSystemRepositoryModalForm";
import CloudStorageRepositoryModalForm from "./CloudStorageRepositoryModalForm";
import HadoopStorageRepositoryModalForm from "./HadoopStorageRepositoryModalForm";
import { STORAGE_REPOSITORY_TYPE } from "./types";
import useDataTiering from "../hooks/useDataTiering";
const RepositorySelectContainer = styled(Col)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    font-size: ${theme.fonts.size.large};
    gap: ${theme.spacings.md};
    margin-top: ${theme.spacings.md};
    margin-bottom: ${theme.spacings.md};
    padding-left: ${theme.spacings.lg};
    padding-right: ${theme.spacings.lg};
  `
);
const SelectLabel = styled.label`
  font-weight: bold;
  font-size: ${({ theme }) => theme.fonts.size.body};
  margin-bottom: ${({ theme }) => theme.spacings.xs};
`;
const CreateRepositoryModal = ({ hideModal, show }) => {
  var _a, _b;
  const { readiness } = useDataTiering();
  const [selectedRepoLocation, setSelectedRepoLocation] = useState(void 0);
  const repositoryLocationLabels = {
    s3: "Amazon S3",
    gcs: "Google Cloud Storage",
    fs: "File System",
    hdfs: "Hadoop Distributed File System",
    azure: "Azure Blob Storage"
  };
  const supportedTypes = (_b = (_a = readiness.data) == null ? void 0 : _a.details.supported_repository_types) != null ? _b : [];
  const repositoryOptions = supportedTypes.map((type) => ({
    value: type,
    label: repositoryLocationLabels[type]
  }));
  const effectiveRepoLocation = selectedRepoLocation != null ? selectedRepoLocation : supportedTypes[0];
  const handleRepositoryTypeChange = (selectedOption) => {
    setSelectedRepoLocation(selectedOption);
  };
  const repositoryForm = () => {
    var _a2;
    if (readiness.isLoading) return /* @__PURE__ */ React.createElement(Spinner, { text: "Fetching configuration information..." });
    if (((_a2 = readiness.data) == null ? void 0 : _a2.details.supported_repository_types.length) === 0) {
      return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "No supported warm storage repository types. Please configure a warm storage repository location.");
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, supportedTypes.length > 1 && /* @__PURE__ */ React.createElement(RepositorySelectContainer, null, /* @__PURE__ */ React.createElement(SelectLabel, { htmlFor: "repository-type-select" }, "Warm Storage Repository Location:"), /* @__PURE__ */ React.createElement(
      Select,
      {
        inputId: "repository-type-select",
        placeholder: "Choose a repository type...",
        value: effectiveRepoLocation,
        onChange: handleRepositoryTypeChange,
        options: repositoryOptions,
        menuPlacement: "auto"
      }
    )), (effectiveRepoLocation === STORAGE_REPOSITORY_TYPE.S3 || effectiveRepoLocation === STORAGE_REPOSITORY_TYPE.GCS || effectiveRepoLocation === STORAGE_REPOSITORY_TYPE.ABS) && /* @__PURE__ */ React.createElement(CloudStorageRepositoryModalForm, { hideModal, type: effectiveRepoLocation }), effectiveRepoLocation === STORAGE_REPOSITORY_TYPE.HDFS && /* @__PURE__ */ React.createElement(HadoopStorageRepositoryModalForm, { hideModal }), effectiveRepoLocation === STORAGE_REPOSITORY_TYPE.FS && /* @__PURE__ */ React.createElement(FileSystemRepositoryModalForm, { hideModal }));
  };
  return /* @__PURE__ */ React.createElement(Modal, { show, bsSize: "large", onHide: hideModal }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Create ", effectiveRepoLocation && `${repositoryLocationLabels[effectiveRepoLocation]} `, "Warm Storage Repository")), repositoryForm());
};
export default CreateRepositoryModal;
